import React, { FC } from 'react'

import { EuiButtonIcon } from '@elastic/eui'

export interface AddCustomSectionButtonProps<T> {
  position: T
  onClick: (position: T) => void
}

export function AddCustomSectionButton<T>({ position, onClick }: AddCustomSectionButtonProps<T>) {
  return <EuiButtonIcon iconType='plus' style={{ color: '#0071c2' }} onClick={() => onClick(position)} aria-label='Add custom section' />
}
